"use strict";

var marko_template = module.exports = require("marko/dist/vdom").t(),
    marko_component = {
        onCreate: function() {
          this.state = {};

          fhandler.bind(this, {
              level: []
            });
        },
        onInput: function(input) {
          input.reset && fhandler.reset();
        },
        onPrev: function() {
          this.emit("prev", this.input.index);
        },
        onNext: function() {
          this.emit("next", this.input.index, this.state.form);
        },
        onSelect: function(level) {
          fhandler.set("level", level);
        }
      },
    components_registry_browser = require("marko/dist/runtime/components/registry-browser"),
    marko_registerComponent = components_registry_browser.r,
    marko_componentType = marko_registerComponent("/MP.WEB$2.0/src/views/smoothy~1.0/pages/Onboarding/components/Experience.marko", function() {
      return module.exports;
    }),
    marko_renderer = require("marko/dist/runtime/components/renderer"),
    marko_defineComponent = require("marko/dist/runtime/components/defineComponent"),
    module_FormHandler = require("markojs-form"),
    FormHandler = module_FormHandler.default || module_FormHandler,
    Locale_template = require("../../../../components/Locale/index.marko"),
    marko_loadTag = require("marko/dist/runtime/helpers/load-tag"),
    Locale_tag = marko_loadTag(Locale_template),
    marko_classValue = require("marko/dist/runtime/helpers/class-value"),
    Row_template = require("../../../../components/Row/index.marko"),
    Row_tag = marko_loadTag(Row_template),
    Bx_template = require("../../../../components/Bx/index.marko"),
    Bx_tag = marko_loadTag(Bx_template),
    AutoScroll_template = require("marko-perfect-scrollbar/index.marko"),
    AutoScroll_tag = marko_loadTag(AutoScroll_template),
    marko_attrs0 = {
        "class": "w-100 p-lg-5 p-2"
      },
    marko_attrs1 = {
        "class": "card-content"
      },
    marko_attrs2 = {
        "class": "d-flex align-items-center"
      },
    marko_createElement = require("marko/dist/runtime/vdom/helpers/v-element"),
    marko_const = require("marko/dist/runtime/vdom/helpers/const"),
    marko_const_nextId = marko_const("060704"),
    marko_node0 = marko_createElement("img", {
        src: "/images/icons/medal.svg",
        alt: "categories",
        width: "60",
        "class": "mr-4"
      }, "4", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_node1 = marko_createElement("br", null, "6", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_node2 = marko_createElement("br", null, "7", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_node3 = marko_createElement("br", null, "8", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_node4 = marko_createElement("br", null, "37", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_node5 = marko_createElement("br", null, "38", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_attrs3 = {
        "class": "navigation-buttons"
      },
    marko_attrs4 = {
        "class": "btn btn-outline-primary btn-xl text-left d-inline-block"
      },
    marko_attrs5 = {
        "class": "btn btn-primary btn-xl text-left d-inline-block float-right w-50"
      },
    marko_attrs6 = {
        "class": "col"
      },
    marko_node6 = marko_createElement("img", {
        src: "/images/medals/089-medal-10.png",
        "class": "w-25"
      }, "12", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_node7 = marko_createElement("br", null, "13", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_attrs7 = {
        "class": "font-medium-4"
      },
    marko_node8 = marko_createElement("br", null, "16", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_attrs8 = {
        "class": "font-small-4"
      },
    marko_attrs9 = {
        "class": "col"
      },
    marko_node9 = marko_createElement("img", {
        src: "/images/medals/088-medal-11.png",
        "class": "w-25"
      }, "21", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_node10 = marko_createElement("br", null, "22", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_attrs10 = {
        "class": "font-medium-4"
      },
    marko_node11 = marko_createElement("br", null, "25", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_attrs11 = {
        "class": "font-small-4"
      },
    marko_attrs12 = {
        "class": "col"
      },
    marko_node12 = marko_createElement("img", {
        src: "/images/medals/006-medal-44.png",
        "class": "w-25"
      }, "30", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_node13 = marko_createElement("br", null, "31", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_attrs13 = {
        "class": "font-medium-4"
      },
    marko_node14 = marko_createElement("br", null, "34", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_attrs14 = {
        "class": "font-small-4"
      };

const fhandler = new FormHandler({ key: 'assessment', autosave: true });

function render(input, out, __component, component, state) {
  var data = input;

  AutoScroll_tag({
      class: "h-100",
      renderBody: function(out) {
        out.be("div", marko_attrs0, "1", component);

        out.be("div", marko_attrs1, "2", component);

        out.be("h5", marko_attrs2, "3", component);

        out.n(marko_node0, component);

        Locale_tag({
            renderBody: function(out) {
              out.t("What's your experience level in using LXP tools?");
            }
          }, out, __component, "5");

        out.ee();

        out.n(marko_node1, component);

        out.n(marko_node2, component);

        out.n(marko_node3, component);

        Row_tag({
            class: "m-0",
            renderBody: function(out) {
              out.be("div", marko_attrs6, "10", component);

              out.be("div", {
                  "class": marko_classValue("card cursor-pointer justify-content-center p-2 " + (state.form.level == "beginner" ? "theme-bg-lighten" : ""))
                }, "11", component, null, 1, {
                  onclick: __component.d("click", "onSelect", false, [
                      "beginner"
                    ])
                });

              out.n(marko_node6, component);

              out.n(marko_node7, component);

              out.be("h6", marko_attrs7, "14", component);

              Locale_tag({
                  text: "Beginner"
                }, out, __component, "15");

              out.ee();

              out.n(marko_node8, component);

              out.be("span", marko_attrs8, "17", component);

              Locale_tag({
                  renderBody: function(out) {
                    out.t("This is my first time using LXP tools");
                  }
                }, out, __component, "18");

              out.ee();

              out.ee();

              out.ee();

              out.be("div", marko_attrs9, "19", component);

              out.be("div", {
                  "class": marko_classValue("card cursor-pointer justify-content-center p-2 " + (state.form.level == "intermetiate" ? "theme-bg-lighten" : ""))
                }, "20", component, null, 1, {
                  onclick: __component.d("click", "onSelect", false, [
                      "intermetiate"
                    ])
                });

              out.n(marko_node9, component);

              out.n(marko_node10, component);

              out.be("h6", marko_attrs10, "23", component);

              Locale_tag({
                  text: "Intermetiate"
                }, out, __component, "24");

              out.ee();

              out.n(marko_node11, component);

              out.be("span", marko_attrs11, "26", component);

              Locale_tag({
                  renderBody: function(out) {
                    out.t("I've used LXP tools couple of times");
                  }
                }, out, __component, "27");

              out.ee();

              out.ee();

              out.ee();

              out.be("div", marko_attrs12, "28", component);

              out.be("div", {
                  "class": marko_classValue("card cursor-pointer justify-content-center p-2 " + (state.form.level == "expert" ? "theme-bg-lighten" : ""))
                }, "29", component, null, 1, {
                  onclick: __component.d("click", "onSelect", false, [
                      "expert"
                    ])
                });

              out.n(marko_node12, component);

              out.n(marko_node13, component);

              out.be("h6", marko_attrs13, "32", component);

              Locale_tag({
                  text: "Expert"
                }, out, __component, "33");

              out.ee();

              out.n(marko_node14, component);

              out.be("span", marko_attrs14, "35", component);

              Locale_tag({
                  renderBody: function(out) {
                    out.t("I've used LXP tools for years");
                  }
                }, out, __component, "36");

              out.ee();

              out.ee();

              out.ee();
            }
          }, out, __component, "9");

        out.ee();

        out.n(marko_node4, component);

        out.n(marko_node5, component);

        out.be("div", marko_attrs3, "39", component);

        out.be("button", marko_attrs4, "40", component, null, 0, {
            onclick: __component.d("click", "onPrev", false)
          });

        Locale_tag({
            text: "Back",
            class: "px-3"
          }, out, __component, "41");

        out.ee();

        out.be("button", marko_attrs5, "42", component, null, 0, {
            onclick: __component.d("click", "onNext", false)
          });

        Bx_tag({
            type: "right-arrow-alt",
            class: "font-large-1 float-right white-text"
          }, out, __component, "43");

        Locale_tag({
            text: "Continue"
          }, out, __component, "44");

        out.ee();

        out.ee();

        out.ee();
      }
    }, out, __component, "0");
}

marko_template._ = marko_renderer(render, {
    e_: marko_componentType
  }, marko_component);

marko_template.Component = marko_defineComponent(marko_component, marko_template._);
